import * as AbsintheSocket from '@absinthe/socket'
import config from 'config'
import { Socket as PhoenixSocket } from 'phoenix'
import { createAbsintheSocketLink } from 'pluralsh-absinthe-socket-apollo-link'

export default createAbsintheSocketLink(
  AbsintheSocket.create(new PhoenixSocket(`${config.app}${config.ws}`))
)
